const initialState = {
  mitraWallet: [],
}

const getters = {
  governmentRevenue: state =>
    !!state.mitraWallet.find(mitraWallet => mitraWallet.product_type === 'government-revenue')
      ?.whitelisted,
}

const mutations = {
  SET_MITRA_WALLET(state, mitraWallet) {
    state.mitraWallet = mitraWallet
  },
}

const actions = {
  async fetch({ commit, _, rootState }) {
    try {
      const { data } = await rootState.apiService.getWhitelist()
      commit('SET_MITRA_WALLET', data?.products || [])
      return data
    } catch {
      commit('SET_MITRA_WALLET', [])
      return []
    }
  },
}

export default {
  getters,
  actions,
  mutations,
  namespaced: true,
  state: () => ({ ...initialState }),
}
